/* Farbvorschau (Modell 194) — Dawn 15.x
   Hört auf Dawns PubSub-Event "variant-change" (global via pubsub.js/constants.js)
   und tauscht das 194-Vorschaubild + Caption passend zur gewählten Farbe.
   Kein eigener Variant-Picker; nur Anzeige.

   Zwei deckungsgleiche Layer (bottom = Untere/Basisfarbe, top = Obere Farbe mit
   CSS-Maske). Einfarbig: beide Layer = dieselbe Farbe → Naht unsichtbar.
   Bi-Color: oben = Obere Farbe, unten = Untere Farbe; die weiche Naht (--seam /
   --feather) steckt in der CSS. */
(function () {
  if (window.customElements.get('color-preview-194')) return;

  class ColorPreview194 extends HTMLElement {
    connectedCallback() {
      this.map = {};
      try {
        this.map = JSON.parse(this.querySelector('.cp194__map').textContent || '{}');
      } catch (e) {
        this.map = {};
      }

      this.imgTop = this.querySelector('.cp194__img--top');
      this.imgBottom = this.querySelector('.cp194__img--bottom');
      this.cap = this.querySelector('.cp194__cap');
      this.farbeIndex = parseInt(this.getAttribute('data-farbe-index'), 10) || 1; // 1-basiert
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._bicolor = false; // Einfarbig-Modus als Default

      // Startfarbe: live selektierte Variante > data-initial-code
      var code = this.currentCodeFromDom() || this.getAttribute('data-initial-code') || '';
      this.applySingle(code);

      // Auf Variantenwechsel hören (im Bi-Color-Modus steuert der Konfigurator die Zonen)
      var self = this;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this._unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (self._bicolor) return;
          var variant = event && event.data && event.data.variant;
          if (!variant || !variant.options) return;
          self.applySingle(variant.options[self.farbeIndex - 1]);
        });
      }
    }

    disconnectedCallback() {
      if (this._unsub) this._unsub();
    }

    // Öffentliche API für bicolor-config.js: Einfarbig (beide Layer = eine Farbe)
    setSingle(code) {
      this._bicolor = false;
      var c = code || this.currentCodeFromDom() || this.getAttribute('data-initial-code') || '';
      this.applySingle(c);
    }

    // Öffentliche API für bicolor-config.js: Bi-Color (obere/untere Zone)
    setBicolor(topCode, bottomCode) {
      this._bicolor = true;

      var topUrl = topCode ? this.map[topCode] : null;
      var botUrl = bottomCode ? this.map[bottomCode] : null;

      // Keine 194-Aufnahme für BEIDE Farben -> Block sauber ausblenden
      if (!topUrl && !botUrl) {
        this.hidden = true;
        return;
      }
      this.hidden = false;

      // Fehlt ein Layer, den vorhandenen als Fallback nehmen (kein Broken-Image).
      this.setLayer(this.imgBottom, botUrl || topUrl);
      this.setLayer(this.imgTop, topUrl || botUrl);

      this.cap.innerHTML =
        'Oben <b>' + (topCode || '—') + '</b> · Unten <b>' + (bottomCode || '—') + '</b> · Darstellung an Modell 194.';
    }

    // Aktuellen Farbcode aus dem gerenderten <variant-selects>-JSON lesen (Fallback/Init)
    currentCodeFromDom() {
      try {
        var node = document.querySelector('variant-selects [data-selected-variant]');
        if (!node) return '';
        var v = JSON.parse(node.textContent);
        if (v && v.options) return v.options[this.farbeIndex - 1] || '';
      } catch (e) {}
      return '';
    }

    // Einfarbig: beide Layer bekommen dasselbe Bild → deckungsgleich, Naht unsichtbar
    applySingle(code) {
      var url = code ? this.map[code] : null;

      // Keine 194-Aufnahme für diese Farbe -> Block sauber ausblenden (kein Broken-Image)
      if (!url) {
        this.hidden = true;
        return;
      }
      this.hidden = false;

      this.setLayer(this.imgBottom, url);
      this.setLayer(this.imgTop, url);
      if (this.imgBottom) this.imgBottom.alt = 'HARBOUR 194 in Farbe ' + code;

      this.cap.innerHTML =
        '<b>Farbe ' + code + '</b> · Farbdarstellung an Modell 194. Die Form Ihrer Fassung bleibt wie im Hauptbild.';
    }

    // Einen Layer mit Crossfade (bzw. sofort bei Erststart/reduzierter Bewegung) setzen
    setLayer(img, url) {
      if (!img) return;
      if (!url) {
        img.removeAttribute('src');
        img.style.opacity = '0';
        return;
      }
      if (this.reduce || !img.getAttribute('src')) {
        img.src = url;
        img.style.opacity = '1';
        return;
      }
      img.style.opacity = '0';
      setTimeout(function () {
        img.src = url;
        requestAnimationFrame(function () {
          img.style.opacity = '1';
        });
      }, 160);
    }
  }

  window.customElements.define('color-preview-194', ColorPreview194);
})();
